import { ChangeEvent } from "react";
import { Col, Form, FormGroup, Input, Label } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { AdharPlaceholder, AgreeToTermsAndConditions, CardHolder, CardNumber, Continue, Previous } from "../../../../Constant";
import ShowError from "../../common/ShowError";
import { PayCardDetails } from "./PayCardDetails";
import { useAppDispatch, useAppSelector } from "../../../../Redux-Toolkit/Hooks";
import { setPayDetailsFormValues } from "../../../../Redux-Toolkit/Reducers/FormLayout/FormWizardTwoSlice";
import { BusinessFormCommonProps } from "../../../../Type/FormLayoutType";

const PayDetailsForm = ({ callbackActive }: BusinessFormCommonProps) => {
  const { payDetailsFormValues } = useAppSelector((state) => state.formWizardTwo);
  const { cardHolderName, cardNumber, expiryDate, expiryYear, cvvNumber } = payDetailsFormValues;
  const dispatch = useAppDispatch();

  const getUserData = (event: ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    const value = event.target.value;
    dispatch(setPayDetailsFormValues({ ...payDetailsFormValues, [name]: value }));
  };

  const handleNextButton = () => {
    if (cardHolderName !== "" && cardNumber !== "" && expiryDate !== "" && expiryYear !== "" && cvvNumber !== "") callbackActive(5);
    else ShowError();
  };

  return (
    <Form onSubmit={(event) => event.preventDefault()} className="row g-3 needs-validation" noValidate>
      <Col md="6">
        <Label check>{CardHolder}</Label>
        <Input value={cardHolderName} name="cardHolderName" onChange={getUserData} type="text" />
      </Col>
      <Col md="6">
        <Label check>{CardNumber}</Label>
        <Input value={cardNumber} name="cardNumber" onChange={getUserData} type="text" placeholder={AdharPlaceholder} />
      </Col>
      <PayCardDetails getUserData={getUserData}/>
      <Col xs="12">
        <FormGroup check className="mb-0">
          <Input id="invalidCheckboxWizard" type="checkbox" />
          <Label className="mb-0" htmlFor="invalidCheckboxWizard" check>{AgreeToTermsAndConditions}</Label>
        </FormGroup>
      </Col>
      <Col xs="12" className="text-end mt-3">
        <Btn color="primary" onClick={() => callbackActive(3)}>{Previous}</Btn>
        <Btn className="ms-1" color="primary" onClick={handleNextButton}>{Continue}</Btn>
      </Col>
    </Form>
  );
};

export default PayDetailsForm;
